import React from "react";

import { LineChart } from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart";
import { Timespan } from "../../../DataDownloadComponents/TimespanPicker/types";
import { FacilityDetailsAnalysisControls } from "../Controls";
import { useIndividualFacilityChart } from "../hooks/useIndividualFacilityChart";
import { useIndividualFacilityChartDetails } from "../hooks/useIndividualFacilityChartDetails";
import { IFacilityDetailsAnalysisChartOptions } from "../types";

export interface IFacilityDetailsAnalysisChartProps {
  locationId: string;
  organizationId?: string | number;
  facilityName?: string;
  timespan: Timespan;
  selectedChartId: number | undefined;
  options: IFacilityDetailsAnalysisChartOptions;
  setOptions: React.Dispatch<
    React.SetStateAction<IFacilityDetailsAnalysisChartOptions>
  >;
}

export const FacilityDetailsAnalysisChart: React.FunctionComponent<
  IFacilityDetailsAnalysisChartProps
> = (props) => {
  const {
    locationId,
    organizationId,
    facilityName,
    selectedChartId,
    options,
    timespan,
  } = props;

  const { data: chartData } = useIndividualFacilityChart(selectedChartId);
  const { currentData, prevYearData, isFetching } =
    useIndividualFacilityChartDetails({
      locationId,
      organizationId,
      chartData,
      timespan,
      options,
    });

  return (
    <div className="facility-details-analysis-chart">
      <FacilityDetailsAnalysisControls
        chartData={chartData}
        chartDetails={currentData}
        prevYearChartDetails={prevYearData}
        compareToPrev={options.compareToPrev}
        timeUnit={options.fidelity}
        facilityName={facilityName}
      />
      <LineChart
        chartDetailsData={isFetching ? undefined : currentData}
        prevYearChartDetailsData={isFetching ? undefined : prevYearData}
        usePrevYear={options.compareToPrev}
        timeUnit={options.fidelity}
        skipLabelTranslation={false}
        aggregation={chartData?.aggregation}
        hideCsvDownloadContainer={true}
      />
    </div>
  );
};
